/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';
export const productDetailsThumbnailSliderSX =
	(slides: number): SxProps<Theme> =>
	(theme) => ({
		position: 'relative',
		textAlign: 'left',
		minWidth: '60px',

		'div, button': {
			outline: 'none',
		},

		'.swiper-button-prev, .swiper-button-next': {
			height: theme.spacing(5),
			width: theme.spacing(5),
			background: 'none',
			borderRadius: '50%',
			border: '1px solid transparent',

			'&:hover': {
				cursor: 'pointer',
				color: theme.palette.primary.main,
				borderColor: theme.palette.primary.light,
			},
			'&::after': {
				fontSize: '20px',
				fontWeight: 'bold',
				color: theme.palette.text.primary,
			},
		},

		[theme.breakpoints.down('md')]: {
			// maxHeight: theme.spacing(50),

			maxHeight: 'none',

			'.swiper-button-prev, .swiper-button-next': {
				position: 'absolute',
				top: '50%',
				transform: 'translateY(-50%)',
			},

			'.swiper-button-prev': {
				left: '0',
			},

			'.swiper-button-next': {
				right: 0,
			},

			'.swiper-pagination': {
				position: 'absolute',
				left: '0 !important',
				right: '0 !important',
				bottom: '18px !important',
				display: 'flex !important',
				justifyContent: 'center !important',
				width: '100% !important',
				overflow: 'visible',
				transform: 'none !important',
			},

			'.swiper-pagination-bullet-active': {
				backgroundColor: '#FFF !important',
				opacity: '1 !important',
			},

			'.swiper-pagination-bullet:first-of-type': {
				borderRadius: slides > 1 ? '3px 0 0 3px !important' : '3px !important',
			},

			'.swiper-pagination-bullet:last-of-type': {
				borderRadius: slides > 1 ? '0 3px 3px 0 !important' : '3px !important',
			},

			'.swiper-pagination-bullet': {
				backgroundColor: '#000000',
				border: 'none',
				opacity: '0.3',
				width: `calc(170px/${slides}) !important`,
				height: '6px !important',
				margin: '0 !important',
				borderRadius: '0', // No !important here to allow override by first/last specific rules? No, specificity should handle it, but Swiper might have radius. Let's start with 0.
				transition: `background-color ${theme.transitions.duration.standard}ms opacity 0.3 ${theme.transitions.easing.easeIn}`,
				display: 'block', // Ensure block behavior inside flex
			},
		},
	});
